module.exports = __webpack_public_path__ + "media/control_acceso/abatible_labeled-0677f80d.png";